import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  align-items: center;
`;

export function PaperBackground(props: { children: React.ReactNode }) {
  return <Container>{props.children}</Container>;
}
